import { FC } from "react";
import { useTranslation } from "react-i18next";
import { useFormik } from "formik";
import * as Yup from "yup";
import {
  FormContainer,
  NextButton,
  Prompt,
  QuestionContainer,
  QuestionPageContainer,
  Scale,
  ScaleInput,
} from "~/OnboardingApp/components";
import { useOnboarding } from "~/OnboardingApp/hooks/useOnboarding";
import { useSubmitOnboardingQuestion } from "~/OnboardingApp/hooks/useSubmitOnboardingQuestion";
import { requiredNumber } from "~/utils/validations";

type Values = {
  howAnxious: Scale | undefined;
};

const validationSchema = Yup.object({
  howAnxious: requiredNumber,
});

export const HowAnxiousPage: FC = () => {
  const { t } = useTranslation();
  const { howAnxious } = useOnboarding();
  const { onSubmit } = useSubmitOnboardingQuestion();

  const initialValues: Values = {
    howAnxious: howAnxious || "",
  };

  const formik = useFormik({
    initialValues,
    onSubmit,
    validationSchema,
    validateOnMount: true,
  });

  return (
    <QuestionPageContainer>
      <FormContainer formik={formik}>
        <QuestionContainer>
          <Prompt question={t("onboarding.howAnxiousPage.question")} />

          <ScaleInput
            autoAdvance
            id="howAnxious"
            scalePath="onboarding.howAnxiousPage"
            defaultValue={howAnxious}
          />
        </QuestionContainer>

        <NextButton showButton={!!howAnxious} />
      </FormContainer>
    </QuestionPageContainer>
  );
};
